import * as Api from '@/api';
import { Usage } from '@/models/packet';
import { defineModule, localActionContext } from 'direct-vuex';
import { WebRequestStatus } from '@/models';
import * as Utils from '@/utils';

interface State {
  usage: Usage;
  status: WebRequestStatus;
}

const zeroUsage = Object.freeze({
  userCount: 0,
  postCount: 0
});

const getInitialState = (): State => {
  return {
    usage: zeroUsage,
    status: WebRequestStatus.READY
  };
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const usageActionContext = (context: any) =>
  // eslint-disable-next-line  @typescript-eslint/no-use-before-define
  localActionContext(context, usageStore);

const usageStore = defineModule({
  namespaced: true as true,
  state: getInitialState(),
  mutations: {
    reset(state) {
      state.usage = getInitialState().usage;
      state.status = getInitialState().status;
    },

    setUsage(state, usage: Usage) {
      state.usage = usage;
    },

    setStatus(state, status: WebRequestStatus) {
      state.status = status;
    }
  },
  actions: {
    async getUsage(context, fetchUsageFn: () => Promise<Usage>) {
      const { commit } = usageActionContext(context);

      commit.reset();
      commit.setStatus(WebRequestStatus.IN_PROGRESS);

      try {
        const usage = await fetchUsageFn();
        commit.setUsage(usage);
        commit.setStatus(WebRequestStatus.SUCCESS);
        await Utils.sleep(1000);
      } catch (error) {
        console.error(error);
        commit.setStatus(WebRequestStatus.FAILURE);
        await Utils.sleep(4000);
      }
      commit.setStatus(WebRequestStatus.READY);
    },

    async getObjectiveUsage(
      context,
      { objectiveId, packetId }: { packetId: number; objectiveId: number }
    ) {
      const { dispatch } = usageActionContext(context);

      await dispatch.getUsage(() =>
        Api.secure.getObjectiveUsage(packetId, objectiveId)
      );
    },

    async getOutcomeUsage(
      context,
      { outcomeId, packetId }: { packetId: number; outcomeId: number }
    ) {
      const { dispatch } = usageActionContext(context);

      await dispatch.getUsage(() =>
        Api.secure.getOutcomeUsage(packetId, outcomeId)
      );
    },

    zero(context) {
      const { commit } = usageActionContext(context);

      commit.reset();
    }
  }
});

export default usageStore;
